export const operationsSteps = ()=>{ 
  return[
  {
    target: '[data-tour="operations-module"]',
    title: '⚙️ Welcome to Operations',
    content:
      'This module provides quick access to all operational tools like payroll, attendance, work week, and more.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="operations-search"]',
    title: '🔍 Search Operations',
    content:
      'Use this search bar to quickly find any module or tool.',
    disableBeacon: true,
  }
];
}